'use strict';

var tib = tib || {};
tib.recoveryPassword = tib.recoveryPassword || {};

let email = null;
let code = null;
let isInvite = 0;

function handleInputState($input, message = null, color = 'red') {
    $input.addClass('failed');
    $input.get(0).focus();
    if (message !== null) {
        $('.password-recovery-messages-container').css('color', color).html(message);
    }
}

function resetInputState() {
    $('input').each(function () {
        $(this).removeClass('failed');
    });
    $('.password-recovery-messages-container').html('');
}

function handleShowPasswordEye() {
    let eye = $(this);
    eye.toggleClass('fa-eye fa-eye-slash');
    let input = $('.' + eye.attr('data-toggle'));
    if (input.attr('type') === 'password') {
        input.attr('type', 'text');
    } else {
        input.attr('type', 'password');
    }
}

function handleEmailInput() {
    resetInputState();
    let $button = $('.password-recovery-email-submit');
    let $spinner = $('<i class="fa fa-refresh fa-spin for-red-button"></i>');
    let $emailInput = $('.password-recovery-email-input');
    email = $emailInput.val();
    if (!email) {
        handleInputState($emailInput, 'Fill in the e-mail field');
        return;
    }
    if (!email.match(/\S+@\S+\.\S+/)) {
        handleInputState($emailInput, 'Invalid e-mail');
        return;
    }
    if (email) {
        $button.append($spinner).prop('disabled',true).addClass('disabled');
        $.ajax({
            url: '/api/auth',
            data:{
                'action' : 'sendPasswordRecoveryCode',
                'email' : email,
            },
            type: 'POST'
        }).done((response) => {
            $spinner.remove();
            $button.attr('disabled', false).removeClass('disabled');
            if (response.success === true) {
                $('.password-recovery-container').html(tib.template['password-recovery/code']);
                $('.password-recovery-code-input').get(0).focus();
            } else {
                if (response.message !== undefined) {
                    handleInputState($emailInput, response.message);
                } else {
                    handleInputState($emailInput, 'Server error. Please, try later');
                }
            }
        });
    }
}

function handleCodeInput() {
    resetInputState();
    let $button = $('.password-recovery-code-submit');
    let $spinner = $('<i class="fa fa-refresh fa-spin for-red-button"></i>');
    let $codeInput = $('.password-recovery-code-input');
    code = $codeInput.val().toUpperCase();
    $codeInput.val(code);
    if (!code) {
        handleInputState($codeInput, 'Fill in the Code field');
        return;
    }
    if (code && email && code.length === 6) {
        $button.append($spinner).prop('disabled',true).addClass('disabled');
        $.ajax({
            url: '/api/auth',
            data:{
                'action' : 'verifyPasswordRecoveryCode',
                'email' : email,
                'code' : code,
                'isInvite': isInvite
            },
            type: 'POST'
        }).done((response) => {
            $spinner.remove();
            $button.attr('disabled', false).removeClass('disabled');
            if (response.success === true) {
                $('.password-recovery-container').html(tib.template['password-recovery/password']);
            } else {
                if (response.message !== undefined) {
                    handleInputState($codeInput, response.message);
                } else {
                    handleInputState($codeInput, 'Server error. Please, try later');
                }
            }
        });
    }
}

function handlePasswordInput() {
    resetInputState();
    let $button = $('.password-recovery-password-submit');
    let $spinner = $('<i class="fa fa-refresh fa-spin for-red-button"></i>');
    let $passwordInput = $('.password-recovery-password-input');
    let $confirmPasswordInput = $('.password-recovery-confirm-password-input');
    let password = $passwordInput.val();
    let confirmPassword = $confirmPasswordInput.val();
    if (!password) {
        handleInputState($passwordInput, 'Fill in the Password field');
        return;
    }
    if (!password.match(/^.{8,}$/gm)) {
        handleInputState($passwordInput, 'Password must be 8 or more characters');
        return;
    }
    if (!confirmPassword) {
        handleInputState($confirmPasswordInput, 'Confirm the password');
        return;
    }
    if (password !== confirmPassword) {
        handleInputState($confirmPasswordInput, 'Password confirmation doesn\'t match password');
        return;
    }
    if (code && email) {
        $button.append($spinner).prop('disabled',true).addClass('disabled');
        $.ajax({
            url: '/api/auth',
            data:{
                'action' : 'recoveryPassword',
                'email' : email,
                'code' : code,
                'password' : password,
                'isInvite': isInvite
            },
            type: 'POST'
        }).done((response) => {
            $spinner.remove();
            $button.attr('disabled', false).removeClass('disabled');
            if (response.success === true) {
                handleInputState(
                    $passwordInput,
                    'Password changed successfully, after 3 seconds, you will be redirected to the main page',
                    'green'
                );
                setTimeout(function () {
                    window.location.replace('/');
                }, 3000);
            } else {
                if (response.message !== undefined) {
                    handleInputState($passwordInput, response.message);
                } else {
                    handleInputState($passwordInput, 'Server error. Please, try later');
                }
            }
        });
    }
}

function initOnCLickButtons() {
    let $body = $('body');
    $body.on('click', '.password-recovery-email-submit', handleEmailInput);
    $body.on('click', '.password-recovery-code-submit', handleCodeInput);
    $body.on('input', '.password-recovery-code-input', handleCodeInput);
    $body.on('click', '.password-recovery-password-submit', handlePasswordInput);
    $body.on('click', '.password-recovery-password-eye', handleShowPasswordEye);
}

function verifyInviteUser() {
    $.ajax({
        url: '/api/auth',
        data:{
            'action' : 'verifyPasswordRecoveryCode',
            'email' : email,
            'code' : code,
            'isInvite': isInvite
        },
        type: 'POST'
    }).done((response) => {
        if (response.success === true) {
            $('.password-recovery-container').html(tib.template['password-recovery/password']({isNew: true}));
        } else {
            if (response.message !== undefined) {
                alert(response.message);
            } else {
                alert('Server error. Please, try later');
            }
        }
    });
}

$(document).ready(function() {
    let params = new URLSearchParams(window.location.search);
    if (params.get('email') && params.get('code')) {
        isInvite = 1;
        code = params.get('code');
        email = params.get('email');
        verifyInviteUser();
    } else {
        $('.password-recovery-container').html(tib.template['password-recovery/email']);
    }
    initOnCLickButtons();
});
